/* NĒM v2: overlay menu, scroll reveal, kit builder.
   No dependencies, nothing blocking, everything degrades to a working page. */
(function () {
  'use strict';

  /* ---- overlay menu ---- */
  var menu = document.getElementById('v2menu');
  var opener = document.querySelector('[data-menu-open]');
  var lastFocus = null;

  function openMenu() {
    if (!menu) return;
    lastFocus = document.activeElement;
    menu.hidden = false;
    document.body.classList.add('v2-locked');
    window.setTimeout(function () { menu.classList.add('is-open'); }, 10);
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var first = menu.querySelector('a, button');
    if (first) first.focus();
  }

  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-open');
    document.body.classList.remove('v2-locked');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () { menu.hidden = true; }, 320);
    if (lastFocus) lastFocus.focus();
  }

  if (opener) opener.addEventListener('click', openMenu);
  if (menu) {
    menu.addEventListener('click', function (e) {
      if (e.target === menu || e.target.closest('[data-menu-close]') || e.target.closest('a')) closeMenu();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
    if (e.key !== 'Tab' || !menu || menu.hidden) return;
    var items = menu.querySelectorAll('a[href], button:not([disabled])');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });


  /* ---- reveal on scroll ---- */
  var targets = document.querySelectorAll('[data-reveal]');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (still || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
      io.observe(el);
    });

    // Failsafe: content must never stay invisible because the observer did not
    // fire for it (a very tall viewport, a screenshot tool, a print). Anything
    // that is on screen a moment later is shown, whatever the observer said.
    var sweep = function () {
      Array.prototype.forEach.call(targets, function (el) {
        var box = el.getBoundingClientRect();
        if (!el.classList.contains('is-in') && box.top < window.innerHeight && box.bottom > 0) {
          el.classList.add('is-in');
        }
      });
    };
    window.setTimeout(sweep, 1500);
    window.addEventListener('load', function () { window.setTimeout(sweep, 400); });
  }

  /* ---- one scroll listener drives the story and the statement ---- */
  var onScroll = [];
  var ticking = false;

  function runScroll() {
    ticking = false;
    for (var i = 0; i < onScroll.length; i++) onScroll[i]();
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(runScroll);
  }, { passive: true });
  window.addEventListener('resize', runScroll, { passive: true });

  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

  /* ---- the device turns while the section is pinned ----
     Twenty three stills only cover the rotation in steps, so the drawing is
     done on a running animation frame: the progress chases the scroll, and the
     two stills around it are blended. Every pixel of scrolling moves the
     device, and a fast flick still rotates through instead of jumping. */
  var story = document.querySelector('[data-story]');
  var canvas = story && story.querySelector('[data-frames]');

  if (canvas && canvas.getContext) {
    var ctx = canvas.getContext('2d', { alpha: true });
    var single = canvas.getAttribute('data-single');
    // one photo is drawn as two identical stills so the scroll maths stays the same
    var count = single ? 2 : (parseInt(canvas.getAttribute('data-count'), 10) || 1);
    var prefix = canvas.getAttribute('data-prefix');
    var ext = canvas.getAttribute('data-ext');
    var frames = [];
    var copies = story.querySelectorAll('.v2-story-copy');
    var bar = story.querySelector('[data-story-bar]');
    var halo = story.querySelector('.v2-story-halo');

    var target = 0;      // where the scroll says we are, 0 to 1
    var current = -1;    // what is on screen, eased towards target
    var running = false;
    var loaded = 0;

    var pad = function (n) { return n < 10 ? '00' + n : (n < 100 ? '0' + n : String(n)); };

    for (var f = 1; f <= count; f++) {
      (function (index) {
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () {
          loaded++;
          if (loaded <= 2 || Math.abs(index - 1 - current * (count - 1)) < 1.5) {
            paint(current < 0 ? 0 : current);
          }
        };
        img.onerror = function () { story.classList.add('is-static', 'is-flat'); };
        var path = single || (prefix + pad(index) + ext);
        // the single file build serves frames from an embedded map
        img.src = (window.OXY_IMG && window.OXY_IMG[path]) || path;
        frames.push(img);
      }(f));
    }

    function usable(img) { return img && img.complete && img.naturalWidth; }

    function cover(img) {
      var boxRatio = canvas.width / canvas.height;
      var imgRatio = img.naturalWidth / img.naturalHeight;
      var w, h;
      if (imgRatio > boxRatio) { w = canvas.width; h = canvas.width / imgRatio; }
      else { h = canvas.height; w = canvas.height * imgRatio; }
      return [(canvas.width - w) / 2, (canvas.height - h) / 2, w, h];
    }

    function paint(progress) {
      var exact = progress * (count - 1);
      var i = Math.floor(exact);
      var frac = exact - i;
      var a = frames[Math.min(i, count - 1)];
      var b = frames[Math.min(i + 1, count - 1)];
      if (!usable(a)) return;

      if (canvas.width !== a.naturalWidth) {
        canvas.width = a.naturalWidth;
        canvas.height = a.naturalHeight;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingQuality = 'high';

      var box = cover(a);
      ctx.globalAlpha = 1;
      ctx.drawImage(a, box[0], box[1], box[2], box[3]);

      // The hand over between two stills happens inside a narrow window, so a
      // still device is never a double exposure, while a moving one blends.
      var mix = still ? 0 : (frac - .34) / .32;
      mix = mix < 0 ? 0 : mix > 1 ? 1 : mix;
      if (mix > 0 && usable(b) && b !== a) {
        ctx.globalAlpha = mix;
        var boxB = cover(b);
        ctx.drawImage(b, boxB[0], boxB[1], boxB[2], boxB[3]);
        ctx.globalAlpha = 1;
      }
    }

    function ease(v) { return v < .5 ? 2 * v * v : 1 - Math.pow(-2 * v + 2, 2) / 2; }

    function segment(progress, from, peak, to) {
      if (progress <= from || progress >= to) return 0;
      if (progress <= peak) return ease((progress - from) / Math.max(.001, peak - from));
      return ease((to - progress) / Math.max(.001, to - peak));
    }

    var STEPS = [
      { from: .02, peak: .18, to: .40 },
      { from: .32, peak: .50, to: .70 },
      { from: .62, peak: .80, to: .99 }
    ];

    function dressCopies(progress) {
      var wide = window.matchMedia('(min-width: 1081px)').matches;
      Array.prototype.forEach.call(copies, function (copy, i) {
        var step = STEPS[i];
        if (!step) return;
        var amount = segment(progress, step.from, step.peak, step.to);
        var side = copy.getAttribute('data-side') === 'start' ? -1 : 1;
        var shiftX = wide ? side * 34 * (1 - amount) : 0;
        var shiftY = (wide ? 18 : 16) * (1 - amount);
        copy.style.opacity = amount;
        copy.style.transform = 'translate3d(' + shiftX.toFixed(1) + 'px, ' + shiftY.toFixed(1) + 'px, 0)';
        copy.classList.toggle('is-on', amount > .5);
      });
    }

    function frame() {
      if (still) {                    // no easing when motion is turned down
        current = Math.round(target * (count - 1)) / (count - 1);
        running = false;
        paint(current);
        return;
      }
      var gap = target - current;
      if (Math.abs(gap) < .0015) {
        // settle on an exact still, never between two
        current = Math.round(target * (count - 1)) / (count - 1);
        running = false;
        paint(current);
        return;
      }
      current += gap * 0.18;          // chase the scroll, never snap to it
      paint(current);
      window.requestAnimationFrame(frame);
    }

    function kick() {
      if (still) {                    // draw straight away, no animation frame
        current = Math.round(target * (count - 1)) / (count - 1);
        paint(current);
        return;
      }
      if (running) return;
      running = true;
      window.requestAnimationFrame(frame);
    }

    onScroll.push(function () {
      var box = story.getBoundingClientRect();
      var span = box.height - window.innerHeight;
      if (span <= 0) return;
      if (box.bottom < -200 || box.top > window.innerHeight + 200) return;

      target = clamp01(-box.top / span);
      if (current < 0) current = target;
      dressCopies(target);
      if (bar) bar.style.width = (target * 100).toFixed(1) + '%';
      if (halo) halo.style.transform = 'scale(' + (.96 + target * .08).toFixed(3) + ')';
      canvas.style.transform = 'scale(' + (.97 + target * .03).toFixed(3) + ')';
      kick();
    });

  } else if (story) {
    story.classList.add('is-static', 'is-flat');
  }

  /* ---- statement: one word at a time, colour only ---- */
  var kara = document.querySelector('[data-kara]');
  if (kara) {
    var words = kara.textContent.trim().split(/\s+/);
    kara.textContent = '';
    words.forEach(function (word, i) {
      var span = document.createElement('span');
      span.className = 'w';
      span.textContent = word;
      kara.appendChild(span);
      if (i < words.length - 1) kara.appendChild(document.createTextNode(' '));
    });
    var spans = kara.querySelectorAll('.w');

    onScroll.push(function () {
      var box = kara.getBoundingClientRect();
      var start = window.innerHeight * 0.85;
      var end = window.innerHeight * 0.25;
      var progress = clamp01((start - box.top) / (start - end));
      var lit = Math.round(progress * spans.length);
      Array.prototype.forEach.call(spans, function (span, i) {
        span.classList.toggle('on', i < lit);
      });
    });
  }

  runScroll();



  /* ---- press video: the iframe only loads when asked ---- */
  var player = document.querySelector('[data-yt]');
  if (player) {
    player.addEventListener('click', function () {
      var id = player.getAttribute('data-yt');
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&hl=he';
      frame.title = 'NĒM בערוץ 14';
      frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      player.innerHTML = '';
      player.appendChild(frame);
    });
  }

  /* ---- the value belt: half its width has to cover the screen ----
     The loop works by sliding exactly half the track, so the other half must
     be at least as wide as the window or a gap opens on a wide monitor. */
  var belt = document.querySelector('[data-belt]');
  if (belt) {
    var BELT_SPEED = 26;   // pixels a second, the same on any screen width
    var fillBelt = function () {
      var guard = 0;
      while (belt.scrollWidth / 2 < window.innerWidth + 80 && guard < 40) {
        belt.appendChild(belt.firstElementChild.cloneNode(true));
        guard++;
      }
      // the loop covers half the track, so the duration follows that distance
      belt.style.animationDuration = Math.round(belt.scrollWidth / 2 / BELT_SPEED) + 's';
    };
    fillBelt();
    var beltTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(beltTimer);
      beltTimer = window.setTimeout(fillBelt, 200);
    });
  }

  /* ---- the line that slaloms between the three steps ----
     Drawn from the real geometry of the cards so it always meets their edges,
     and it draws itself in as the section comes up the screen. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-flow]'), function (flow) {
    var svg = flow.querySelector('.v2-flow-line');
    var steps = flow.querySelectorAll('.v2-step');
    if (!svg || steps.length < 2) return;

    var line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    var head = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    head.setAttribute('class', 'head');
    svg.appendChild(line);
    svg.appendChild(head);

    function build() {
      var box = flow.getBoundingClientRect();
      if (!box.width) return;
      svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
      var d = '';
      var last = null;

      for (var i = 0; i < steps.length - 1; i++) {
        var a = steps[i].getBoundingClientRect();
        var b = steps[i + 1].getBoundingClientRect();
        var ax = a.left + a.width / 2 - box.left;
        var ay = a.bottom - box.top + 8;
        var bx = b.left + b.width / 2 - box.left;
        var by = b.top - box.top - 8;
        var pull = Math.max(26, (by - ay) * 0.55);
        d += 'M ' + ax + ' ' + ay + ' C ' + ax + ' ' + (ay + pull) + ' ' + bx + ' ' + (by - pull) + ' ' + bx + ' ' + by + ' ';
        last = [bx, by];
      }

      line.setAttribute('d', d.trim());
      if (last) {
        // a small chevron so the line reads as an arrow into the last card
        head.setAttribute('d', 'M ' + (last[0] - 6) + ' ' + (last[1] - 7) +
                               ' L ' + last[0] + ' ' + last[1] +
                               ' L ' + (last[0] + 6) + ' ' + (last[1] - 7));
      }

      var length = line.getTotalLength ? line.getTotalLength() : 0;
      line.style.strokeDasharray = length;
      line.dataset.length = length;
      if (still) {
        line.style.strokeDashoffset = 0;
        head.style.opacity = '';
      } else {
        paintLine();
      }
    }

    function paintLine() {
      var length = parseFloat(line.dataset.length || '0');
      if (!length) return;
      var box = flow.getBoundingClientRect();
      var from = window.innerHeight * 0.9;
      var to = window.innerHeight * 0.35;
      var progress = clamp01((from - box.top) / (from - to));
      line.style.strokeDashoffset = length * (1 - progress);
      head.style.opacity = progress > 0.92 ? '' : '0';
    }

    build();
    window.addEventListener('load', build);
    // card heights settle after the webfont lands, and the column height comes
    // from the clip beside it, so watch the box instead of guessing a moment
    if (window.ResizeObserver) new ResizeObserver(build).observe(flow);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    var t;
    window.addEventListener('resize', function () {
      window.clearTimeout(t);
      t = window.setTimeout(build, 150);
    });
    if (!still) onScroll.push(paintLine);
  });

  /* ---- rails move by one card, and know when they are at an end ---- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), function (rail) {
    var nav = rail.parentNode.querySelector('.v2-rail-nav');
    if (!nav) return;
    var prev = nav.querySelector('[data-rail-prev]');
    var next = nav.querySelector('[data-rail-next]');
    var step = function () {
      var card = rail.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : 280;
    };
    var ends = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var at = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = at <= 2;
      if (next) next.disabled = at >= max;
    };
    // scrollLeft runs negative in a right to left rail, so the sign follows it
    var dir = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
    if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= step() * dir; });
    if (next) next.addEventListener('click', function () { rail.scrollLeft += step() * dir; });
    rail.addEventListener('scroll', ends, { passive: true });
    window.addEventListener('resize', ends);
    ends();
  });

  /* ---- collection: chips and colour dots filter the grid ---- */
  var chips = document.querySelector('[data-filter]');
  var dots = document.querySelector('[data-filter-color]');
  var cards = document.querySelectorAll('.v2-card');

  if (cards.length && (chips || dots)) {
    var kind = 'all';
    var colour = null;

    function applyFilter() {
      var shown = 0;
      Array.prototype.forEach.call(cards, function (card) {
        var okKind = kind === 'all' || card.getAttribute('data-kind') === kind;
        var okColour = !colour || card.getAttribute('data-c') === colour;
        var show = okKind && okColour;
        card.hidden = !show;
        if (show) shown++;
      });
      var note = document.querySelector('.v2-grid-note p');
      if (note) note.textContent = 'מוצגים ' + shown + ' מתוך ' + cards.length + ' מוצרים';
    }

    if (chips) {
      chips.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        chips.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        kind = btn.getAttribute('data-f');
        applyFilter();
      });
    }

    if (dots) {
      dots.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var wasOn = btn.classList.contains('is-on');
        dots.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
        if (wasOn) {
          colour = null;
        } else {
          btn.classList.add('is-on');
          colour = btn.getAttribute('data-c');
          // a colour only exists on refills, so move the chips along with it
          if (chips) {
            chips.querySelectorAll('button').forEach(function (b) {
              b.classList.toggle('is-on', b.getAttribute('data-f') === 'refill');
            });
            kind = 'refill';
          }
        }
        applyFilter();
      });
    }
  }

  /* ---- product: gallery, options, quantity, sticky bar ---- */
  var thumbs = document.querySelector('[data-thumbs]');
  var main = document.getElementById('pdMain');
  if (thumbs && main) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      var pick = btn.getAttribute('data-src');
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = pick;
    });
  }

  /* ---- product: variant pills, starter refill, quantity, running total ---- */
  var pd = document.querySelector('[data-pd]');
  var pdJson = pd && pd.querySelector('[data-pd-json]');

  function formatMoney(cents) {
    var format = (window.oxyvape && window.oxyvape.moneyFormat) || '{{amount}} ₪';
    var value = (cents / 100).toFixed(2);
    var whole = Math.round(cents / 100).toString();
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  if (pd && pdJson) {
    var data = JSON.parse(pdJson.textContent);
    var form = pd.querySelector('[data-pd-form]');
    var idField = pd.querySelector('[data-pd-variant]');
    var addonField = pd.querySelector('[data-pd-addon-id]');
    var qtyWrap = pd.querySelector('[data-pd-qty]');
    var qtyField = qtyWrap && qtyWrap.querySelector('input');
    var priceEl = pd.querySelector('[data-pd-price]');
    var compareEl = pd.querySelector('[data-pd-compare]');
    var submit = pd.querySelector('[data-pd-submit]');
    var label = pd.querySelector('[data-pd-label]');
    var totals = document.querySelectorAll('[data-pd-total], [data-pd-total-2]');
    var mainImg = document.getElementById('pdMain');
    var addonPrice = 0;

    var current = data.variants.filter(function (v) { return String(v.id) === idField.value; })[0] || data.variants[0];

    function chosenOptions() {
      return Array.prototype.map.call(pd.querySelectorAll('[data-pd-option]'), function (group) {
        var on = group.querySelector('button.is-on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function refresh() {
      var qty = qtyField ? Math.max(1, parseInt(qtyField.value, 10) || 1) : 1;
      var sum = current.price * qty + addonPrice;
      if (priceEl) priceEl.textContent = formatMoney(current.price);
      if (compareEl) compareEl.textContent = current.compare > current.price ? formatMoney(current.compare) : '';
      Array.prototype.forEach.call(totals, function (el) { el.textContent = formatMoney(sum); });
      if (submit) submit.disabled = !current.available;
      if (label) label.textContent = current.available ? data.labels.add : data.labels.soldOut;
      idField.value = current.id;
    }

    Array.prototype.forEach.call(pd.querySelectorAll('[data-pd-option]'), function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        var wanted = chosenOptions();
        var match = data.variants.filter(function (v) {
          return v.options.every(function (value, i) { return wanted[i] === null || wanted[i] === value; });
        })[0];
        if (match) {
          current = match;
          if (match.image && mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = match.image;
          }
        }
        refresh();
      });
    });

    var addonGroup = pd.querySelector('[data-pd-addon]');
    if (addonGroup && addonField) {
      addonGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        addonGroup.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        var none = btn.hasAttribute('data-none');
        addonField.value = none ? '' : btn.getAttribute('data-id');
        addonPrice = none ? 0 : parseInt(btn.getAttribute('data-price'), 10) || 0;
        refresh();
      });
    }

    if (qtyWrap && qtyField) {
      qtyWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        var next = (parseInt(qtyField.value, 10) || 1) + parseInt(btn.getAttribute('data-step'), 10);
        qtyField.value = Math.max(1, Math.min(20, next));
        refresh();
      });
      qtyField.addEventListener('change', refresh);
    }

    var stickySubmit = document.querySelector('[data-sticky-submit]');
    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    refresh();
  }

  var stickyBuy = document.querySelector('[data-sticky-buy]');
  var buyBlock = document.querySelector('.v2-pd-cta');
  if (stickyBuy && buyBlock) {
    onScroll.push(function () {
      var past = buyBlock.getBoundingClientRect().bottom < 0;
      stickyBuy.classList.toggle('is-on', past);
    });
  }

  /* ---- kit builder ---- */
  var kit = document.querySelector('[data-kit]');
  var build = kit && kit.querySelector('[data-pick="device"]');
  if (build) {
    var groups = kit.querySelectorAll('[data-pick]');
    var total = kit.querySelector('[data-kit-total]');
    var was = kit.querySelector('[data-kit-was]');
    var link = kit.querySelector('[data-kit-link]');
    var CURRENCY = kit.getAttribute('data-currency') || 'ש"ח';
    var DISCOUNT = (parseFloat(kit.getAttribute('data-discount')) || 0) / 100;

    function money(n) { return Math.round(n) + ' ' + CURRENCY; }

    function sum() {
      var full = 0;
      var picked = [];
      Array.prototype.forEach.call(groups, function (group) {
        group.querySelectorAll('button.is-on').forEach(function (b) {
          full += parseFloat(b.getAttribute('data-price') || '0');
          var id = b.getAttribute('data-id');
          if (id) picked.push(id + ':1');
        });
      });
      if (total) total.textContent = money(full * (1 - DISCOUNT));
      if (was) was.textContent = DISCOUNT > 0 ? money(full) : '';
      // a cart permalink adds every chosen item in one go, with no script on
      // the checkout side and no extra request here
      if (link && picked.length) link.setAttribute('href', '/cart/' + picked.join(','));
    }

    Array.prototype.forEach.call(groups, function (group) {
      var max = parseInt(group.getAttribute('data-max') || '1', 10);
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        if (max === 1) {
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
        } else if (btn.classList.contains('is-on')) {
          if (group.querySelectorAll('button.is-on').length > 1) btn.classList.remove('is-on');
        } else {
          var on = group.querySelectorAll('button.is-on');
          if (on.length >= max) on[0].classList.remove('is-on');
          btn.classList.add('is-on');
        }
        sum();
      });
    });
    sum();
  }
}());
